import { useState } from "react";
import styles from "./admin.module.css";
import useTestimonials from "../../hooks/useTestimonials";
import { deleteTestimonial } from "../../data/firestore";

const formatDate = (ts) => {
  if (!ts?.toDate) return "";
  return ts.toDate().toLocaleDateString("en-IN", {
    day: "numeric",
    month: "short",
    year: "numeric",
  });
};

export default function TestimonialsManager() {
  const { testimonials, loading } = useTestimonials();
  const [busyId, setBusyId] = useState(null);

  const handleDelete = async (id) => {
    if (!window.confirm("Remove this testimonial? This can't be undone.")) return;
    setBusyId(id);
    try {
      await deleteTestimonial(id);
    } finally {
      setBusyId(null);
    }
  };

  return (
    <div>
      <div className={styles.head}>
        <h2 className={styles.heading}>Testimonials</h2>
        <span className={styles.count}>
          {loading ? "Loading…" : `${testimonials.length} published`}
        </span>
      </div>

      <p className={styles.hint} style={{ marginBottom: "1rem" }}>
        Anyone can post a testimonial from the public site. They appear
        immediately — review and remove anything inappropriate here.
      </p>

      {!loading && testimonials.length === 0 && (
        <div className={styles.empty}>No testimonials yet.</div>
      )}

      <ul className={styles.list}>
        {testimonials.map((t) => (
          <li key={t.id} className={styles.row}>
            <div className={styles.rowBody}>
              <p className={styles.rowTitle}>{t.name}</p>
              <p className={styles.rowMeta}>
                {[t.context, t.area].filter(Boolean).join(" · ")}
                {t.createdAt && ` · ${formatDate(t.createdAt)}`}
              </p>
              <p className={styles.rowText}>&ldquo;{t.quote}&rdquo;</p>
            </div>
            <div className={styles.rowActions}>
              <button
                type="button"
                className={`${styles.btn} ${styles.btnDanger}`}
                onClick={() => handleDelete(t.id)}
                disabled={busyId === t.id}
              >
                {busyId === t.id ? "Removing…" : "Remove"}
              </button>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}
